<template>
  <div class="container-inbound-waiting">
    <div class="box-title" style="display:flex;justify-content: space-between">
      <h4>
        <i class="fal fa-scanner"></i>
        {{$t('Sidebar.ຄັງພັດສະດຸສູນຄັດແຍກ')}} (ລໍຖ້າຍິງເຂົ້າ)
        <span class="countTotal"></span>
        <vs-button
            :loading="isExporting"
            @click="exportShipmentOrdersToExcel"
            color="whatsapp" style="position: absolute;right: 0;top: 50px;">
          Export Excel
        </vs-button>
      </h4>
    </div>
    <div class="box" v-if="isRoleService === 'service'">
      <div class="columns">
        <div class="column is-12">
          <div class="control">
            <label class="label">ເລືອກສາຂາເບິ່ງຕາມສູນຄັດແຍກ:</label>
            <div class="field">
              <div class="control">
                <model-list-select
                    style="z-index: 999999999"
                    :list="distributionCenters"
                    v-model="ServiceSelectDistributionCenter"
                    placeholder="ເລືອກສູນຄັດແຍກ"
                    option-text="name"
                    option-value="id"
                    selectedItem="name">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <div class="control">
              <label class="label">ຄົ້ນຫາ:</label>
              <input
                  v-model="searchItem"
                  @keyup.enter="FilterData()"
                  class="input"
                  placeholder="ຄົ້ນຫາ..."
              >
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                type="date"
                :clearable="false"
                name="start_date"
                v-model="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-4">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                type="date"
                :clearable="false"
                name="end_date"
                v-model="end_date"
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <div class="control">
            <label>ປະເພດຜູ້ຍິງອອກ :</label>
            <div class="group-radio">
              <vs-radio val="1" v-model="selectedItem">
                ສາຂາ
              </vs-radio>
              <vs-radio val="2" v-model="selectedItem">
                ສູນຄັດແຍກ
              </vs-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div v-if="selectedItem == 1" class="column is-10">
          <div class="control">
            <label class="label">ເລືອກສາຂາ:</label>
            <div class="field">
              <div class="control">
                <model-list-select
                    :list="branches"
                    v-model="selectedBranch"
                    placeholder="ເລືອກສາຂາກ່ອນ"
                    option-text="name"
                    option-value="id"
                    selectedItem="name">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-10" v-else>
          <div class="control" v-if="selectedItem == 2">
            <model-list-select
                :list="distributionCenters"
                v-model="selectDistributionCenter"
                placeholder="ເລືອກສູນຄັດແຍກ"
                option-text="name"
                option-value="id"
                selectedItem="name">
            </model-list-select>
          </div>
        </div>
        <div class="column is-2">
          <div class="field" style="padding-top: 4px;">
            <div class="control">
              <vs-button
                ref="button" flat
                @click="FetchData"
                class="form-btn-loading"
                :loading="isLoading">
                {{ $t("ລາຍການOrderພັດສະດຸ.ຄົ້ນຫາ") }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ເລກບິນ</vs-th>
            <vs-th>ຈາກສາຂາ</vs-th>
            <vs-th></vs-th>
            <vs-th>ຫາສາຂາ</vs-th>
            <vs-th>ຜູ້ຍິງພັດສະດຸ</vs-th>
            <vs-th>ວັນເວລາຍິງ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr v-for="(item,index) in parcelUnInbound" :key="index">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ item.parcel_in_shipment.parcel_bill_number }}</vs-td>
            <vs-td>{{ item.shipment.start_branch.name }}</vs-td>
            <td><i style="color: red;font-size: 1.2rem" class="fas fa-long-arrow-alt-right"></i></td>
            <vs-td>{{ item.shipment.end_branch.name }}</vs-td>
            <vs-td>{{ item.created_by_user.name }}</vs-td>
            <vs-td>{{ FormatDateTime(item.created_at) }}</vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>

    </div>
  </div>
</template>

<script>
import Loading from "@views/Loading";
import DatePicker from "vue2-datepicker";
import pagination from "@/Plugins/Paginations/CusorPagination";
import {ModelListSelect} from 'vue-search-select';
import moment from "moment";
import * as helper from "@/Helpers/GetValue";
import {FormatDate} from "@/Helpers/Format";

export default {
  name: "Parcel-Inbound-Waiting",
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    pagination,
  },
  data() {
    return {
      isRoleService: "",
      selectedItem: "1",
      branches: [],
      selectedBranch: null,
      selectDistributionCenter: null,
      ServiceSelectDistributionCenter: "",
      isLoading: true,
      distributionCenters: [],
      start_date: moment().subtract(3, 'days').toDate(),
      end_date: new Date(),
      searchItem: "",
      parcelUnInbound: [],
      // Pagination
      page: 1,
      max: 10,
      offset: 10,
      count: 0,
      pagination: {},
      per_page: 10,
      limit_page: 10,
      getDistributionCenterId: "",
      isExporting: false,
    }
  },
  watch: {
    'selectedBranch': function () {
      this.selectDistributionCenter = null;
      this.FetchData();
    },
    'start_date': function () {
      // this.FetchData();
    },
    'end_date': function () {
      // this.FetchData();
    },
    'selectDistributionCenter': function () {
      this.selectedBranch = null;
      this.FetchData();
    },
    'ServiceSelectDistributionCenter': function (val) {
      this.getDistributionCenterId = val;
      this.FetchData();
    },
    'searchItem': function (value) {
      if (value == '') {
        this.FetchData();
      }
    },
  },
  computed: {
    getUserDistributionCenterId() {
      return this.$store.getters.get_distributionCenter_id;
    }
  },
  methods: {
    FormatDateTime(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
      }
    },
    exportShipmentOrdersToExcel() {
      if (this.isExporting) {
        return;
      }
      this.isExporting = true;
      /// Preparing data
      const body = {
        shipment_pay_type: "",
        userId: null,
        start_branch: null,
        end_branch: null,
        sort_order: "desc",
        force_id: "true",
        request_inventory: "true",
        is_only_count: "false",
        branch_id: null,
        distribution_center_id: this.getDistributionCenterId ? this.getDistributionCenterId :
            (this.getUserDistributionCenterId || 'all'),
        sender_branch_id: this.selectedBranch ? this.selectedBranch : null,
        sender_distribution_center_id: this.selectDistributionCenter ? this.selectDistributionCenter : null,
        status: "un-inbound",
        query: this.searchItem,
        start_date: moment(this.start_date).format('YYYY-MM-DD 00:00:00.000'),
        end_date: moment(this.end_date).format('YYYY-MM-DD 23:59:59.000'),
        cursor: null,
        per_page: 12,
      };
      this.$http.post('v1/auth/branches/shipments/exports/orders/checking/shipment-holding', body,
          {responseType: 'blob'}).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.setAttribute('download',
            `Exported - Shipments ເຄື່ອງຄ້າງສາງ ສູນຄັດແຍກ - ${this.$t(`pages.ຍິງເຄື່ອງເຂົ້າ`)} - Date at ${FormatDate(body.start_date)}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.isExporting = false;
      }).catch(() => {
        this.isExporting = false;
      })
    },
    FilterData() {
      helper.GetOldValueOnInput(this);
    },
    FetchListBranches() {
      this.$http.get('v1/listing/branches?type=&include=excluded').then((res) => {
        this.branches = res.data;
        this.branches.unshift({
          id: "",
          name: 'ທັງໝົດ'
        });
      })
    },
    FetchDistributionCenter() {
      this.$http.get('v1/listing/distribution_centers').then(res => {
        if (res) {
          this.distributionCenters = res.data;
        }
      }).catch(() => {
      });
    },
    countData() {
      return this.fetchItemsResponse({isCount: true}).then((res) => {
        if (!res.data.error) {
          this.$emit('dataCountUpdated', {
            'count': res.data.count,
            type: 'un_inbound_count'
          })
        }
      }).catch(() => {
      });
    },
    FetchData() {
      this.isLoading = true;
      this.fetchItemsResponse().then((res) => {
        if (!res.data.error) {
          setTimeout(() => {
            this.parcelUnInbound = res.data.data;
            console.log(this.parcelUnInbound.length)
            this.pagination = res.data;
          }, 300);
          this.isLoading = false;
        }

      }).catch(() => {
        this.isLoading = false;
      });
      /// Counting data
      this.countData()
    },
    fetchItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('v1/auth/branches/shipments/orders/tracking/holding-shipments', {
        params: {
          shipment_pay_type: "",
          userId: null,
          end_branch: null,
          sort_order: "desc",
          is_only_count: options.isCount ?? false,
          force_id: true,
          request_inventory: "true",
          branch_id: null,
          distribution_center_id: this.getDistributionCenterId ? this.getDistributionCenterId :
              (this.getUserDistributionCenterId || 'all'),
          sender_branch_id: this.selectedBranch ? this.selectedBranch : null,
          sender_distribution_center_id: this.selectDistributionCenter ? this.selectDistributionCenter : null,
          status: "un-inbound",
          query: this.searchItem,
          start_date: moment(this.start_date).format('YYYY-MM-DD 00:00:00.000'),
          end_date: moment(this.end_date).format('YYYY-MM-DD 23:59:59.000'),
          cursor: current_page ?? this.pagination.cursor,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
  },
  created() {
    this.FetchListBranches();
    this.FetchDistributionCenter();
    this.ServiceSelectDistributionCenter = this.getUserDistributionCenterId;
    this.isRoleService = this.$store.getters.checkIsServiceRole;
  }
}
</script>

<style scoped lang="scss">
.group-radio {
  display: flex;
  margin-top: 6px;
}
</style>
